export const LoginPayloadFragment = /* GraphQL */ `
	fragment LoginPayloadFragment on LoginSilentPayload {
		token
		role {
			_id
			type
			username
			first_name
			last_name
			position
			permissions
		}
	}
`;
